module.exports = __webpack_public_path__ + "static/media/riipiminen.92a6b724.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/riipiminen.jpg
 ** module id = 392
 ** module chunks = 0
 **/